'use strict';

var _ = require('lodash');
var LowestClassOpenTransformerFactory = function LowestClassOpenTransformerFactory(DataTransformer, momentService, configurationService, idService) {
  function LowestClassOpenTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'rom-analysis-loco-mode';
  }
  LowestClassOpenTransformer.prototype = Object.create(DataTransformer.prototype);
  LowestClassOpenTransformer.constructor = LowestClassOpenTransformer;
  LowestClassOpenTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  LowestClassOpenTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  LowestClassOpenTransformer.prototype.isCacheable = function () {
    return true;
  };
  LowestClassOpenTransformer.prototype.transform = function (data) {
    var dataset = data.domain.lowestClassOpenList;
    var memoizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var rtpRanges = configurationService.getParsedRTPS();
    _.forEach(dataset, function (record) {
      if (!record.actualLocoMetrics) {
        //record was already processed
        return;
      }
      var actualLocoMetrics = record.actualLocoMetrics;
      var maxRevLocoMetrics = record.maxRevLocoMetrics;
      record.optClass = maxRevLocoMetrics.lowestClass;
      record.actClass = actualLocoMetrics.lowestClass;
      record.classGap = maxRevLocoMetrics.lowestClassRank - actualLocoMetrics.lowestClassRank;
      record.optFare = maxRevLocoMetrics.lowestClassFare;
      record.actFare = actualLocoMetrics.lowestClassFare;
      record.fareGap = maxRevLocoMetrics.lowestClassFare - actualLocoMetrics.lowestClassFare;
      record.demand = actualLocoMetrics.demandFC;
      record.revGap = maxRevLocoMetrics.revenue - actualLocoMetrics.revenue;
      record.spillPaxGap = maxRevLocoMetrics.spillPax - actualLocoMetrics.spillPax;
      record.recapPaxGap = maxRevLocoMetrics.recapPax - actualLocoMetrics.recapPax;
      record.service = idService.parseServiceId(record.serviceId);

      //implementation with "delete" takes 2.5 sec. more on 250000 records
      record.actualLocoMetrics = undefined;

      //implementation with "delete" takes 2.5 sec. more on 250000 records
      record.maxRevLocoMetrics = undefined;
      record.departureTimeMoment = memoizedMomentOfDepartureDate(record.departureTime, momentService.FIELD.DEPARTURE_TIME, 'HHmm');
      record.departureDateMoment = memoizedMomentOfDepartureDate(record.departureDate, momentService.FIELD.DEPARTURE_DATE);
      record.dow = record.dayOfWeek.slice(0, 3).toUpperCase();
      record.dayOfWeek = undefined;
      record.daysToDeparture = rtpRanges[record.romTimeBucket - 1];
      record.romTimeBucket = record.romTimeBucket - 1;
    });
    return dataset;
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  return LowestClassOpenTransformer;
};
LowestClassOpenTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'ConfigurationService', 'IdService'];
module.exports = LowestClassOpenTransformerFactory;